import { Link } from "react-router-dom";
import { CaretLeft, FileArrowDown } from "@phosphor-icons/react";
import { DocsPanel } from "./AdminCrawlers";

export default function AdminCrawledDocs() {
  return (
    <div className="min-h-screen" data-testid="admin-crawled-docs-page">
      <div className="border-b border-zinc-200 bg-[#F4F4F5]">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-4 sm:py-6">
          <Link to="/admin/crawlers" className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-[0.2em] text-[#6043EF] mb-2 hover:underline" data-testid="crawled-docs-back-link">
            <CaretLeft size={11} weight="bold" /> Back to Crawlers
          </Link>
          <h1 className="text-xl sm:text-2xl lg:text-4xl font-bold tracking-tight leading-none text-[#09090B] font-heading flex items-center gap-2">
            <FileArrowDown size={26} weight="bold" className="text-[#6043EF]" /> Documents crawled
          </h1>
        </div>
      </div>
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-4 sm:py-6">
        <DocsPanel />
      </div>
    </div>
  );
}
